<dw-dynamic-routing-init></dw-dynamic-routing-init>

<dw-layout *ngIf="showLayout" [sidebarMinimized]="minimizeSidebar" [bodyClasses]="themeClasses">
    <div logo>
    </div>

    <div topMenu style="display:inline-flex;">
        <div class="alert alert-warning env-message" [hidden]="!environmentMessage" style="margin-left:50px; margin-top:12px;" >
            {{environmentMessage}}
        </div>

        <div class="alert alert-danger" [hidden]="!missingTrustUserIdMessage" style="margin-top:12px;float:left;margin-left:6px;" >
           {{missingTrustUserIdMessage}} <i class="fa fa-info-circle" title="wApps will not work correctly without a Trust User Id.  This can be set manually in Security User Admin"></i>
        </div>
    </div>
</dw-layout> 
